import { HTTPError } from '~/features/commerce-api/http-error';
import { AltaPayErrorCode } from '~/services/altapay/constants';
import { AltaPay } from '~/services/altapay/types';

export interface RequestFailure {
    errorCode?: number;
    errorMessage: string;
    status?: number;
    path: string;
}

export const isAltaPayError = (value: unknown): value is AltaPay.Schemas['ErrorResponse'] =>
    value !== null && typeof value === 'object' && 'errorCode' in value && 'errorMessage' in value;

export const hasAltaPayErrorCode = (error: unknown, errorCode: AltaPayErrorCode) =>
    isAltaPayError(error) && error.errorCode === errorCode;

export const isUnauthorized = (error: unknown) =>
    hasAltaPayErrorCode(error, AltaPayErrorCode.UNAUTHORIZED) ||
    hasAltaPayErrorCode(error, AltaPayErrorCode.AUTHENTICATION_FAILED);

export const isSessionNotFound = (error: unknown) =>
    hasAltaPayErrorCode(error, AltaPayErrorCode.SESSION_NOT_FOUND);

export class MissingBasketError extends Error {
    constructor() {
        super('The customer has no basket.');
        this.name = 'MissingBasketError';
    }
}

export const isMissingBasketError = (error: unknown) =>
    error instanceof MissingBasketError ||
    (error instanceof HTTPError && error.type === 'BasketNotFoundException');
